import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import locales from '../locales';

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: process.env.NODE_ENV === 'development',
        lng: 'fr',
        fallbackLng: 'fr',
        ns: ['page', 'component', 'schema', 'app', 'error'],
        defaultNS: 'page',
        interpolation: {
            escapeValue: false,
        },
        resources: locales
    });

export default i18next;
